import { createSelector } from '@reduxjs/toolkit';
import { type UploadFile } from 'antd';
import { type RootState } from 'email/store';

const baseSelector = (state: RootState) => state.email.email;

export const contentSelector = createSelector(
  baseSelector,
  (email) => email.content,
);

export const subjectSelector = createSelector(
  baseSelector,
  (email) => email.subject,
);

export const ccSelector = createSelector(
  baseSelector,
  (email) => email.cc,
);

export const bccSelector = createSelector(
  baseSelector,
  (email) => email.bcc,
);

export const toSelector = createSelector(
  baseSelector,
  (email) => email.to,
);

export const templateNameSelector = createSelector(
  baseSelector,
  (email) => email.name,
);

export const templateTypeSelector = createSelector(
  baseSelector,
  (email) => email.templateType,
);

export const attachmentsSelector = createSelector(
  baseSelector,
  (email) => email.attachments,
);

export const attachmentsUrlSelector = createSelector(
  attachmentsSelector,
  (attachments) => attachments.map((file: UploadFile) => file?.response?.url).filter(Boolean),
);

export const attachmentsBlobIdsSelector = createSelector(
  attachmentsSelector,
  (attachments) => attachments
    .map((file: any) => file.response?.blob_id)
    .filter(Boolean),
);

export const combinedEmailSelector = createSelector(
  [toSelector, ccSelector, bccSelector, subjectSelector, contentSelector, attachmentsUrlSelector],
  (to, cc, bcc, subject, template, attachments) => ({
    to: to.map(({ email }) => email),
    cc,
    bcc,
    subject,
    template,
    attachments,
  }),
);

export const combinedEmailTemplateSelector = createSelector(
  [templateTypeSelector, templateNameSelector, subjectSelector, contentSelector],
  (templateType, name, subject, template) => ({
    templateType,
    name,
    subject,
    template,
  }),
);
